// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  paymentAndTransactionFormSchema,
  PaymentAndTransactionValuesType,
  paymentAndTransactionInitialValues,
} from "./_formTypes";
import {
  useGetPayment3DTrxSettingsList,
  GetPaymentAndTransactionRequest,
  useGetPaymentAndTransaction,
  useCancelPaymentAndTransaction,
  CancelPaymentAndTransactionRequest,
  useRefundPaymentAndTransaction,
  RefundPaymentAndTransactionRequest,
  useGetTrxStatusSettingsList,
  PagingResponse,
  useAuthorization,
  useGetMerchantVPosList,
  useGetMemberVPosList,
  useGetMerchantsWithParentMerchant,
  usePostRequestReportForTransactionList,
  postTransactionReportRequestList,
  useGetTransactionPaymentModel,
  useGetCityList,
} from "../../../hooks";
import {
  GridColDef,
  GridActionsCellItem,
  GridValueFormatterParams,
  GridPaginationModel,
  GridExpandMoreIcon,
} from "@mui/x-data-grid";
import { default as dayjs } from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import {
  FormControl,
  Link,
  Box,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button as MaterialButton
} from "@mui/material";
import { Button, MerchantSelector, Loading } from "../../atoms";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DateTimePickerControl,
  SelectControl,
  InputControl,
  Table,
  DeleteConfirmModal,
  NumericFormatInputControl,
  createBooleanOperator,
  PaymentAndTransactionMaster,
  ReportRequestListModal,
  DatePickerControl
} from "../../molecules";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import BarChartIcon from '@mui/icons-material/BarChart';
import AddchartIcon from '@mui/icons-material/Addchart';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';

export const PaymentAndTransactionFilter = () => {
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [userInfo] = useUserInfo();
  const [queryOptions, setQueryOptions] = React.useState({});
  const { control, handleSubmit, setValue, getValues } =
    useForm<PaymentAndTransactionValuesType>({
      resolver: zodResolver(paymentAndTransactionFormSchema),
      defaultValues: paymentAndTransactionInitialValues,
    });
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [tableselectedRow, setTableSelectedRow] = useState({} as any);
  const {
    mutate: GetPaymentAndTransaction,
    isLoading: isGetPaymentAndTransactionLoading,
  } = useGetPaymentAndTransaction();
  const {
    mutate: PostRequestReportForTransactionList,
    isLoading: isPostRequestReportForTransactionList,
  } = usePostRequestReportForTransactionList();
  const {
    mutate: CancelPaymentAndTransaction,
    isLoading: isCancelPaymentAndTransactionLoading,
  } = useCancelPaymentAndTransaction();
  const {
    mutate: RefundPaymentAndTransaction,
    isLoading: isRefundPaymentAndTransactionLoading,
  } = useRefundPaymentAndTransaction();
  const { data: rawTransactionStatusList } = useGetTrxStatusSettingsList({});
  const { data: rawPayment3DTrxSettingsList } = useGetPayment3DTrxSettingsList(
    {}
  );
  const { data: rawTransactionPaymentModelList } = useGetTransactionPaymentModel(
    {}
  );
  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [showTable, setShowTable] = useState(false)
  const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetMerchantsWithParentMerchant(null);
  const { mutate: getMemberVPosList, data: rawMemberVPosList } =
    useGetMemberVPosList();
  const { mutate: getMerchantVPosList, isLoading } = useGetMerchantVPosList();
  const setSnackbar = useSetSnackBar();
  useEffect(() => {
    setValue("startDate", dayjs().add(-1, "day"));
    setValue("endDate", dayjs());
  }, [setValue]);

  const [isReportListActive, setIsReportListActive] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [merchantBankList, setMerchantBankList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [selectedCity, setSelectedCity] = useState<{ label: string; value: number } | null>(null);
  const transactionStatusList = useMemo(() => {
    return rawTransactionStatusList?.data?.map(
      (resourceType: { value: string; key: string }) => {
        return {
          label: resourceType.value,
          value: `${resourceType.key}`,
        };
      }
    );
  }, [rawTransactionStatusList?.data]);

  const payment3DTrxSettingsList = useMemo(() => {
    return rawPayment3DTrxSettingsList?.data
      ?.filter((resourceType) => resourceType.status === "ACTIVE")
      .map((resourceType: { value: string; key: string }) => {
        return {
          label: resourceType.value,
          value: `${resourceType.key}`,
        };
      });
  }, [rawPayment3DTrxSettingsList?.data]);

  const transactionPaymentModelList = useMemo(() => {
    return rawTransactionPaymentModelList?.data
      ?.filter((resourceType) => resourceType.status === "ACTIVE")
      .map((resourceType: { value: string; key: string }) => {
        return {
          label: resourceType.value,
          value: `${resourceType.key}`,
        };
      });
  }, [rawTransactionPaymentModelList?.data]);


  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);




  useEffect(() => {
    const savedFilter = localStorage.getItem("paymentAndTranactionFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);




  useEffect(() => {
    if (userInfo?.merchantId == 0) {
      getMemberVPosList(
        {
          orderBy: "CreateDate",
          orderByDesc: true,
          status: "ACTIVE",
        },
        {
          onSuccess: (data) => {
            const bankList = data?.data?.map(
              (bank: { bankCode: string; bankName: string }) => {
                return {
                  label: `${bank.bankName}`,
                  value: bank.bankCode,
                };
              }
            );
            setBankList(bankList);
          },
        }
      );
    } else {
      getMerchantVPosList(
        {
          size: -1,
          page: 0,
          orderBy: "CreateDate",
          orderByDesc: true,
          status: "ACTIVE",
        },
        {
          onSuccess: (data) => {
            const bankList = data?.data?.result
              .filter((bank: { merchantId: number }) => {
                return bank.merchantId == Number(userInfo.merchantId);
              })
              .map(
                (bank: {
                  bankCode: string;
                  bankName: string;
                  merchantId: number;
                }) => {
                  return {
                    label: `${bank.bankName}`,
                    value: bank.bankCode,
                  };
                }
              );

            setBankList(bankList);
          },
        }
      );
    }
  }, [getMerchantVPosList, getMemberVPosList, userInfo.merchantId]);



  const [formValues, setFormValues] = useState<GetPaymentAndTransactionRequest | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false)
  const onSubmit = (data: PaymentAndTransactionValuesType) => {
    setPaginationModel({
      page: 0,
      pageSize: paginationModel.pageSize
    });
    setFilterAccordionExpand(false);
    const filterMerchantId = Array.isArray(data.merchantId) ? data.merchantId : [data.merchantId];
    setTableData(undefined);
    setShowTable(true)
    const req: GetPaymentAndTransactionRequest = {
      startDate: data?.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: data.endDate
        ? dayjs(data.endDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId,
      filters: []
    };

    if (data.cardNumber) {
      req.filters.push({
        field: "maskedPan",
        values: [data.cardNumber],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.orderId) {
      req.filters.push({
        field: "orderId",
        values: [data.orderId],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.authCode) {
      req.filters.push({
        field: "authCode",
        values: [data.authCode],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.status) {
      req.filters.push({
        field: "status",
        values: [data.status],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.transactionType) {

      // if (data.transactionType == "REFUND") {
      //   req.filters.push({
      //     field: "updatedStatus",
      //     values: ["Refunded"],
      //     operationType: 6,
      //     valueType: 1
      //   })
      // } else if (data.transactionType == "PREAUTH") {
      //   req.filters.push({
      //     field: "updatedStatus",
      //     values: ["PreAuth"],
      //     operationType: 6,
      //     valueType: 1
      //   })
      // }
      // else if (data.transactionType == "POSTAUTH") {
      //   req.filters.push({
      //     field: "updatedStatus",
      //     values: ["PostAuth"],
      //     operationType: 6,
      //     valueType: 1
      //   })
      // }
      // else {
      //   req.filters.push({
      //     field: "txnType",
      //     values: [data.transactionType],
      //     operationType: 1,
      //     valueType: 1
      //   })
      // }


      req.filters.push({
        field: "updatedStatus",
        values: [data.transactionType],
        operationType: 6,
        valueType: 1
      })
    }

    if (data.bankCode) {
      req.filters.push({
        field: "bankCode",
        values: [data.bankCode],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.filterMerchantId && data.filterMerchantId.length > 0) {

      var strMerchantId = data.filterMerchantId.map(x => `${x}`);

      req.filters.push({
        field: "filterMerchantId",
        values: strMerchantId,
        operationType: 1,
        valueType: 2
      });
      // req.filterMerchantId = data.filterMerchantId;
    }

    if (data.originalPaymentModel) {
      req.filters.push({
        field: "originalPaymentModel",
        values: [data.originalPaymentModel],
        operationType: 6,
        valueType: 1
      })
    }

    if (selectedCity && selectedCity.value) {
      req.filters.push({
        field: "cityId",
        values: [selectedCity.value.toString()],
        operationType: 1,
        valueType: 2
      });
    }

    setFormValues(req);
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (!isSubmitted || !formValues) {
      return;
    }

    refreshData();

  }, [formValues, isSubmitted, queryOptions, paginationModel]);


  function refreshData() {
    const requestPayload = {
      ...formValues,
      ...getQueryParams(queryOptions),
      size: paginationModel.pageSize,
      page: paginationModel.page,
    };

    if (requestPayload.filters) {
      requestPayload.filters = [
        ...requestPayload.filters,
        ...dynamicFilters
      ]
    }

    // requestPayload.filters = dynamicFilterList;

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    GetPaymentAndTransaction(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }

  function RenderActionButton(transaction: any) {
    let buttonLabel = "";
    let buttonColor = "";

    if (transaction.status.toUpperCase() === "SUCCESS" && transaction.updatedStatus.toUpperCase() !== "REFUND" && transaction.amount > 0 && transaction.paymentSessionToken == null) {
      if (dayjs(transaction.systemDate).format('DD.MM.YYYY') != dayjs(new Date()).format('DD.MM.YYYY') || (transaction.endOfDayFlag && transaction.partialRefundFlag == false && transaction.refundFlag == false)) {
        buttonLabel = "İade";
        buttonColor = "#EEAB00";
      } else if (!transaction.endOfDayFlag) {
        buttonLabel = "İptal";
        buttonColor = "#F5004A";
      }
    }

    return (
      <>
        <Link
          component="button"
          variant="body2"
          sx={{ color: buttonColor }}
          onClick={() => {
            setTableSelectedRow(transaction);
            buttonLabel === "İade" ? setIsRefundModalOpen(true) : setIsCancelModalOpen(true);
          }}
        >
          {buttonLabel}
        </Link>
      </>
    );
  }





  const handleCloseCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCloseRefundModal = () => {
    setIsRefundModalOpen(false);
    setValue("refundAmount", "");
  };

  const deleteRow = React.useCallback(
    (transaction: any) => () => {
      setTableSelectedRow(transaction);
    },
    []
  );
  const handleCancelConfirm = () => {
    const req: CancelPaymentAndTransactionRequest = {
      merchantId: tableselectedRow?.filterMerchantId || 0,
      orderId: tableselectedRow?.orderId || "",
      description: "",
    };
    CancelPaymentAndTransaction(req, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });

          refreshData();

          return;
          const requestParams = {
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            startDate: dayjs(getValues("startDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            endDate: dayjs(getValues("endDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            orderId: getValues("orderId"),
            cardNumber: getValues("cardNumber"),
            authCode: getValues("authCode"),
            status: getValues("status"),
            transactionType: getValues("transactionType"),
            bankCode: getValues("bankCode"),
            merchantId: +userInfo?.merchantId,
          }
          const filterMerchantId = getValues("filterMerchantId");
          if (filterMerchantId && (!Array.isArray(filterMerchantId) || filterMerchantId.length > 0)) {
            requestParams.filterMerchantId = filterMerchantId;
          }
          GetPaymentAndTransaction(
            requestParams,
            {
              onSuccess: (data) => {
                // Burada başladığım kodu yerleştirin
                if (data.isSuccess) {
                  if (data.data && data.data.length === 0) {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "success",
                      isOpen: true,
                      description: data.message,
                    });
                  }
                } else {
                  if (data.message === "Kayit bulunamadi") {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "error",
                      description: data.message,
                      isOpen: true,
                    });
                  }
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "İşlem sırasında bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseCancelModal();
  };

  const handleRefundConfirm = () => {
    const rawValue = getValues("refundAmount");
    const sanitizedValue = rawValue.replace(/,/g, '').replace('.', '');
    const refundAmount = Number(sanitizedValue) || 0;
    const req: RefundPaymentAndTransactionRequest = {
      merchantId: tableselectedRow?.filterMerchantId || 0,
      orderId: tableselectedRow?.orderId || "",
      description: "",
      refundAmount: refundAmount,
    };
    RefundPaymentAndTransaction(req, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          refreshData();
          return;
          const requestParams = {
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            startDate: dayjs(getValues("startDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            endDate: dayjs(getValues("endDate")).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            orderId: getValues("orderId"),
            cardNumber: getValues("cardNumber"),
            authCode: getValues("authCode"),
            status: getValues("status"),
            transactionType: getValues("transactionType"),
            bankCode: getValues("bankCode"),
            merchantId: +userInfo?.merchantId,
          }
          const filterMerchantId = getValues("filterMerchantId");
          if (filterMerchantId && (!Array.isArray(filterMerchantId) || filterMerchantId.length > 0)) {
            requestParams.filterMerchantId = filterMerchantId;
          }
          GetPaymentAndTransaction(
            requestParams,
            {
              onSuccess: (data) => {
                // Burada başladığım kodu yerleştirin
                if (data.isSuccess) {
                  if (data.data && data.data.length === 0) {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "success",
                      isOpen: true,
                      description: data.message,
                    });
                  }
                } else {
                  if (data.message === "Kayit bulunamadi") {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "info",
                      isOpen: true,
                      description: "Listede Kayıt Yoktur",
                    });
                  } else {
                    setTableData(data.data);
                    setSnackbar({
                      severity: "error",
                      description: data.message,
                      isOpen: true,
                    });
                  }
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "İşlem sırasında bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseRefundModal();
  };
  const booleanOptions = [
    { label: "Evet", value: true },
    { label: "Hayır", value: "false" },
  ];
  const currencyDesc = [
    { label: "TRY", value: "TRY" },
    { label: "USD", value: "USD" },
    { label: "EUR", value: "EUR" }
  ];


  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => [
          !!showDelete ? (
            <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              icon={RenderActionButton(params.row)}
            />
          ) : (
            <></>
          ),
        ],
      },
      { field: "statusDesc", headerName: "İşlem Durumu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "txnTypeDesc", headerName: "İşlem Tipi", width: 150, columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "paymentModel", headerName: "Ödeme Tipi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "originalPaymentModel", headerName: "O. Ödeme Tipi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "paymentSource", headerName: "Ödeme Kanalı", width: 150, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "filterMerchantId", headerName: "Üye İşyeri Numarası", width: 180,
        renderCell: (params) => params.value ? params.value.toString() : "", columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantName",
        headerName: "Üye İşyeri Adı",
        width: 300,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "mcc", headerName: "MCC", width: 180, columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "merchantStatus", headerName: "Üye İşyeri Durumu", width: 180,
        renderCell: (params) => params.value == "PASSIVE" ? "Pasif" : (params.value == "BLOCKED" ? "Blokeli" : ""), columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "mobilePos",
        headerName: "Mobil Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN,
      },
      {
        field: "vpos",
        headerName: "Sanal Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "pos",
        headerName: "Fiziksel Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "cepPos",
        headerName: "Cep Pos",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "orderId",
        headerName: "Sipariş Numarası",
        width: 400,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: 'paymentSessionToken',
        headerName: 'Payment Session Token',
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "maskedPan", headerName: "Kart Numarası", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardBankCode", headerName: "Kartın Banka Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardBankName", headerName: "Kartın Banka Adı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardTypeDesc", headerName: "Kart Tipi Açıklama", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "cardType", headerName: "Kart Tipi", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "isBusinessCard", headerName: "Ticari Kart mı?", width: 200, columnType: RequestFilterValueTypeEnums.BOOLEAN, filterOperators: [createBooleanOperator(booleanOptions)],
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
      },
      { field: "bankName", headerName: "Banka Adı", width: 300, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "cardHolderName",
        headerName: "İşlem Yapılan Kart Bilgisi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      { field: "installmentCount", headerName: "Taksit Sayısı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "currencyDesc", headerName: "Para Birimi", width: 150, filterOperators: [createBooleanOperator(currencyDesc)], },
      { field: "currency", headerName: "Para Birimi Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "amount",
        headerName: "Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "totalComission",
        headerName: "Komisyon Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "bankCommissionAmount",
        headerName: "Banka Komisyon Tutarı",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "totalAmount",
        headerName: "Toplam Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "refundAmount",
        headerName: "İade Edilen Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "remainingTotalAmount",
        headerName: "Net Tutar",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "remainingTotalAmountConverted",
        headerName: "Net Tutar TL",
        width: 200,
        renderCell: (params) => (
          <div>
            {params.value != null
              ? parseFloat(params.value).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) + " TL"
              : "0.00 TL"}
          </div>
        ),
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "ftpCommission",
        headerName: "FTP Komisyon",
        type: 'decimalOnly',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return '';
          }
          return `${params.value}`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantAmount",
        headerName: "İşyeri Tutarı",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "integratorCommissionRate",
        headerName: "Entegratör Komisyon Oranı",
        width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        type: 'decimalPercentage',
      },
      {
        field: "integratorAdditionalCommision", headerName: "Entegratör Ek Komisyon Tutarı", width: 250,
        columnType: RequestFilterValueTypeEnums.NUMBER,
        type: "decimal",
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        }, columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "integratorCommission", headerName: "Entegratör Komisyon Tutarı", width: 250,
        type: "decimal",
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        }, columnType: RequestFilterValueTypeEnums.NUMBER
      },

      { field: "revenue", headerName: "AHL Pay Kar", width: 150, columnType: RequestFilterValueTypeEnums.NUMBER },
      { field: "linkPaymentCount", headerName: "Kalan Kullanım", width: 150, valueFormatter: (params) => { return params.value ?? '-' }, columnType: RequestFilterValueTypeEnums.NUMBER },
      { field: "userCode", headerName: "Kullanıcı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "userCodeFullName", headerName: "Kullanıcı Adı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "userPortfolioFullName", headerName: "Satış Portföy Adı", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "requestIp", headerName: "Gönderilen IP", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "requestContextIp", headerName: "İstek IP", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "uniqueHeader", headerName: "Unique Header", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "clientPort", headerName: "İstek Port", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "description", headerName: "Açıklama", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "payerNote", headerName: "Vkn-FirmaUnvan", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "paymentDescription", headerName: "Ödeme Açıklaması", width: 300, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "webUrl", headerName: "WEB Url", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "failUrl", headerName: "Başarısız İşleme Ait URL", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "okUrl", headerName: "Başarılı İşleme Ait URL", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "commissionFlag",
        headerName: "Komisyonu Son Kullanıcıya Yansıt",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "bankcommission", headerName: "Banka Komisyonu %", width: 200, type: "decimalOnly", columnType: RequestFilterValueTypeEnums.NUMBER },
      {
        field: "merchantcommision",
        headerName: "Üye İşyeri Komisyonu %",
        type: "decimalOnly",
        width: 200,
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "merchantadditionalcommision",
        headerName: "Üye İşyeri Sabit Komisyonu",
        type: 'decimal',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      {
        field: "bankblocked",
        headerName: "Banka Blokesi",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "bankblockedday", headerName: "Banka Bloke Günü", width: 200, columnType: RequestFilterValueTypeEnums.NUMBER },
      {
        field: "merchantblocked",
        headerName: "Üye İşyeri Blokesi",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "merchantblockedday",
        headerName: "Üye İşyeri Bloke Günü",
        width: 200,
        columnType: RequestFilterValueTypeEnums.NUMBER
      },
      { field: "authCode", headerName: "Otorizasyon Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "bankResponseCode", headerName: "Banka Cevap Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "bankResponseCodeDesc", headerName: "Banka Cevap Açıklaması", width: 240, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "responseCode", headerName: "Cevap Kodu", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      { field: "responseMessage", headerName: "Cevap Açıklaması", width: 200, columnType: RequestFilterValueTypeEnums.STRING },
      {
        field: "endOfDayFlag",
        headerName: "Gün Sonu",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      { field: "endOfDayId", headerName: "Gün Sonu ID", width: 200, columnType: RequestFilterValueTypeEnums.NUMBER },
      { field: "endOfDayDate", headerName: "Gün Sonu Tarihi", width: 200, columnType: RequestFilterValueTypeEnums.DATE },
      { field: "systemDateFormatted", headerName: "İşlem Tarihi", width: 200, columnType: RequestFilterValueTypeEnums.DATE },
      {
        field: "createDateFormatted",
        headerName: "İşlemin Başlama Tarihi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "updateDateFormatted",
        headerName: "İşlem Bitiş Tarihi",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "createDate", headerName: "Oluşturma Tarihi", width: 200,
        columnType: RequestFilterValueTypeEnums.DATE,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm:ss");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "id", headerName: "ID", width: 200, columnType: RequestFilterValueTypeEnums.NUMBER },

      {
        field: "isCeppos",
        headerName: "CepPOS işlemi mi?",
        width: 200,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
        filterOperators: [createBooleanOperator(booleanOptions)],
        columnType: RequestFilterValueTypeEnums.BOOLEAN
      },
      {
        field: "latitude",
        headerName: "Latitude",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "longitude",
        headerName: "Longitude",
        width: 200,
        columnType: RequestFilterValueTypeEnums.STRING
      },
      {
        field: "cityName",
        headerName: "Şehir",
        width: 180,
        columnType: RequestFilterValueTypeEnums.STRING
      },
    ];
  }, [deleteRow, showDelete]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    return;
    const req: GetPaymentAndTransactionRequest = {
      startDate: getValues("startDate")
        ? dayjs(getValues("startDate")).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: getValues("endDate")
        ? dayjs(getValues("endDate")).format("YYYY-MM-DD HH:mm:ss")
        : "",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId,
      filters: []
    };

    if (getValues("cardNumber")) {
      req.filters.push({
        field: "maskedPan",
        values: [getValues("cardNumber")],
        operationType: 1,
        valueType: 1
      });
    }

    if (getValues("orderId")) {
      req.filters.push({
        field: "orderId",
        values: [getValues("orderId")],
        operationType: 1,
        valueType: 1
      })
    }

    if (getValues("authCode")) {
      req.filters.push({
        field: "authCode",
        values: [getValues("authCode")],
        operationType: 1,
        valueType: 1
      })
    }

    if (getValues("status")) {
      req.filters.push({
        field: "status",
        values: [getValues("status")],
        operationType: 1,
        valueType: 1
      })
    }

    if (getValues("transactionType")) {
      req.filters.push({
        field: "transactionType",
        values: [getValues("transactionType")],
        operationType: 1,
        valueType: 1
      })
    }

    if (getValues("bankCode")) {
      req.filters.push({
        field: "bankCode",
        values: [getValues("bankCode")],
        operationType: 1,
        valueType: 1
      });
    }

    // const formMerchantId = getValues("filterMerchantId");
    // if (formMerchantId) {
    //   req.filterMerchantId = formMerchantId;
    // } else if (data && data.filterMerchantId) {
    //   req.filterMerchantId = data.filterMerchantId;
    // }
    // GetPaymentAndTransaction(req, {
    //   onSuccess: (data) => {
    //     if (data.isSuccess) {
    //       setTableData(data.data);
    //       setSnackbar({
    //         severity: "success",
    //         isOpen: true,
    //         description: data.message,
    //       });
    //     } else {
    //       setSnackbar({
    //         severity: "error",
    //         description: data.message,
    //         isOpen: true,
    //       });
    //     }
    //   },
    //   onError: () => {
    //     setSnackbar({
    //       severity: "error",
    //       description: "İşlem sırasında bir hata oluştu",
    //       isOpen: true,
    //     });
    //   },
    // });
  };



  const keyMapping = {
    statusForExel: "statusForExel",
    txnTypeForExel: "txnTypeForExel"
  };
  const onSave = () => {

    const data = getValues();

    const req: GetPaymentAndTransactionRequest = {
      startDate: data?.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      endDate: data.endDate
        ? dayjs(data.endDate).format("YYYY-MM-DD HH:mm:ss")
        : "",
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      merchantId: +userInfo.merchantId,
      reportType: 1,
      filters: [
        ...dynamicFilters
      ]
    };

    if (data.cardNumber) {
      req.filters.push({
        field: "maskedPan",
        values: [data.cardNumber],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.orderId) {
      req.filters.push({
        field: "orderId",
        values: [data.orderId],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.authCode) {
      req.filters.push({
        field: "authCode",
        values: [data.authCode],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.status) {
      req.filters.push({
        field: "status",
        values: [data.status],
        operationType: 1,
        valueType: 1
      })
    }

    if (data.originalPaymentModel) {
      req.filters.push({
        field: "originalPaymentModel",
        values: [data.originalPaymentModel],
        operationType: 6,
        valueType: 1
      })
    }

    // if (data.transactionType == "REFUND") {
    //   req.filters.push({
    //     field: "updatedStatus",
    //     values: ["Refunded"],
    //     operationType: 6,
    //     valueType: 1
    //   })
    // } else if (data.transactionType == "PREAUTH") {
    //   req.filters.push({
    //     field: "updatedStatus",
    //     values: ["PreAuth"],
    //     operationType: 6,
    //     valueType: 1
    //   })
    // }
    // else if (data.transactionType == "POSTAUTH") {
    //   req.filters.push({
    //     field: "updatedStatus",
    //     values: ["PostAuth"],
    //     operationType: 6,
    //     valueType: 1
    //   })
    // }
    if (data.transactionType) {
      req.filters.push({
        field: "updatedStatus",
        values: [data.transactionType],
        operationType: 6,
        valueType: 1
      })
    }

    if (data.bankCode) {
      req.filters.push({
        field: "bankCode",
        values: [data.bankCode],
        operationType: 1,
        valueType: 1
      });
    }

    if (data.filterMerchantId && data.filterMerchantId.length > 0) {

      var strMerchantId = data.filterMerchantId.map(x => `${x}`);

      req.filters.push({
        field: "filterMerchantId",
        values: strMerchantId,
        operationType: 1,
        valueType: 2
      });
    }

    if (selectedCity && selectedCity.value) {
      req.filters.push({
        field: "cityId",
        values: [selectedCity.value.toString()],
        operationType: 1,
        valueType: 2
      });
    }

    PostRequestReportForTransactionList(
      req,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setSnackbar({
              severity: "info",
              isOpen: true,
              description: data.data,
            });
          } else {
            if (data.message === "Kayit bulunamadi") {
              setSnackbar({
                severity: "info",
                isOpen: true,
                description: "Listede Kayıt Yoktur",
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );

    return;
    function fieldValue(data) {
      return data.map((item) => {
        return {
          "Üye İşyeri Numarası": item?.filterMerchantId,
          "Üye İşyeri Adı": item?.merchantName,
          "Mobil Pos": item?.mobilePos ? "Evet" : "Hayır",
          "Sanal Pos": item?.vpos ? "Evet" : "Hayır",
          "Fiziksel Pos": item?.pos ? "Evet" : "Hayır",
          "Cep Pos": item?.cepPos ? "Evet" : "Hayır",
          "Kullanıcı": item?.userCode,
          "Kart Numarası": item?.maskedPan,
          "Sipariş Numarası": item?.orderId,
          "Orjinal İşlem Numarası": item?.originalOrderId,
          "Banka Adı": item?.bankName,
          "Para Birimi": item?.currencyDesc,
          "İşlem Durumu": item?.statusDesc,
          "İşlem Tarihi": item?.systemDateFormatted,
          "WEB Url": item?.webUrl,
          "Taksit Sayısı": item?.installmentCount,
          "Toplam Tutar": item?.totalAmount,
          "Tutar": item?.amount,
          "Komisyon Tutar": item?.totalComission,
          "Banka Komisyon Tutarı": item?.bankCommissionAmount,
          "İşlem Tipi": item?.txnTypeDesc,
          "Ödeme Tipi": item?.paymentModel,
          "İstek IP": item?.requestIp,
          "Açıklama": item?.description,
          "Para Birimi Kodu": item?.currency,
          "İşlem Yapılan Kart Bilgisi": item?.cardHolderName,
          "Başarısız İşleme Ait URL": item?.failUrl,
          "Başarılı İşleme Ait URL": item?.okUrl,
          "Banka Blokesi": item?.bankblocked ? "Evet" : "Hayır",
          "Banka Bloke Günü": item?.bankblockedday,
          "Banka Komisyonu %": item?.bankcommission,
          "Üye İşyeri Blokesi": item?.merchantblocked ? "Evet" : "Hayır",
          "Üye İşyeri Bloke Günü": item?.merchantblockedday,
          "Üye İşyeri Komisyonu %": item?.merchantcommision,
          "Üye İşyeri Sabit Komisyonu": item?.merchantadditionalcommision,
          "Komisyonu Son Kullanıcıya Yansıt": item?.commissionFlag ? "Evet" : "Hayır",
          "Kart Tipi": item?.cardType,
          "Kart Tipi Açıklama": item?.cardTypeDesc,
          "Otorizasyon Kodu": item?.authCode,
          "Gün Sonu": item?.endOfDayFlag ? "Evet" : "Hayır",
          "Gün Sonu ID": item?.endOfDayId,
          "Gün Sonu Tarihi": item?.endOfDayDate,
          "Kartın Banka Kodu": item?.cardBankCode,
          "Kartın Banka Adı": item?.cardBankName,
          "Banka Cevap Kodu": item?.bankResponseCode,
          "Banka Cevap Açıklaması": item?.bankResponseCodeDesc,
          "Cevap Kodu": item?.responseCode,
          "Cevap Açıklaması": item?.responseMessage,
          "İşlemin Başlama Tarihi": item?.createDateFormatted,
          "İşlem Bitiş Tarihi": item?.updateDateFormatted,
          "ID": item?.id,
          "Sistem Tarihi": item?.systemDateFormatted,
          "Oluşturma Tarihi": item?.createDate,
          "AHL Pay Kar": item?.revenue,
          "Komisyon Oranı": item?.integratorCommissionRate,
          "Komisyon Tutarı": item?.integratorCommissionAmount,
          "MCC": item?.mcc,

          [keyMapping["statusForExel"]]: item?.status,
          [keyMapping["txnTypeForExel"]]: item?.txnType,
        };
      });
    }

    // if (tableData) {
    //   const refactoredData = fieldValue(tableData.result);
    //   downloadExcel(refactoredData || [], "Ödeme ve İslem Raporu", keyMapping);
    //   return;
    // }

    const formData = getValues();

    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      startDate: dayjs(getValues("startDate")).format("YYYY-MM-DD HH:mm:ss"),
      endDate: dayjs(getValues("endDate")).format("YYYY-MM-DD HH:mm:ss"),
      merchantId: +userInfo.merchantId,
      exported: true,
      ...getQueryParams(queryOptions),
    };
    if (formData.orderId) requestPayload.orderId = formData.orderId;
    if (formData.cardNumber) requestPayload.cardNumber = formData.cardNumber;
    if (formData.authCode) requestPayload.authCode = formData.authCode;
    if (formData.status) requestPayload.status = formData.status;
    if (formData.transactionType) requestPayload.transactionType = formData.transactionType;
    if (formData.bankCode) requestPayload.bankCode = formData.bankCode;
    if (formData.filterMerchantId !== undefined && formData.filterMerchantId !== null && formData.filterMerchantId.length > 0) {
      requestPayload.filterMerchantId = formData.filterMerchantId;
    }
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }


    GetPaymentAndTransaction(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {

            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Ödeme ve İslem Raporu", keyMapping);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  useEffect(() => {
    if (isRefundModalOpen && tableselectedRow?.remainingTotalAmount) {
      setValue("refundAmount", tableselectedRow?.remainingTotalAmount.toString());
    }
  }, [isRefundModalOpen, tableselectedRow, setValue]);


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };


  const decimalFields = ['totalAmount', 'amount', 'totalComission'];

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      let value = filters[key];
      if (value === "false") {
        queryParams[key] = false;
      } else if (key === 'filterMerchantId') {
        if (value !== null && value !== undefined && value.toString().length > 0) {
          queryParams['filterSubMerchantId'] = Number(value);
        }
      } else if (value !== null && value !== undefined && value.toString().length > 0) {
        if (decimalFields.includes(key) && !isNaN(parseFloat(value))) {
          queryParams[key] = Number(parseFloat(value).toFixed(2));
        } else {
          queryParams[key] = value;
        }
      }
    }
    return queryParams;
  };

  const convertTableFiltersToRequestFilter = (tableFilters) => {

    let convertedFilters = [];

    tableFilters.items.map((item) => {
      var findColumn = columns.find(x => x.field == item.field);

      convertedFilters.push({
        field: item.field,
        values: [item.value.toString()],
        valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
        operationType: mapReactMUIToFilterOperationTypes(item.operator)
      });
    });

    return convertedFilters;
  }

  const [dynamicFilters, setDynamicFilter] = useState([]);

  const handleFilterChange = debounce((filters, tableFilters) => {
    if (filters.clearFilter) {
      setDynamicFilter([]);
      localStorage.removeItem('paymentAndTranactionFilter')
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      if (key === 'installmentCount' || key === 'cardType' || key === 'amount' || key === 'totalAmount' || key === 'totalComission') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
      localStorage.setItem('paymentAndTranactionFilter', JSON.stringify(queryParams));
    }

    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

  const previousQueryParams = React.useRef({});


  const handleFilterAccordionChange = (event, expanded) => {
    setFilterAccordionExpand(expanded);
    setShowTable(!expanded);
  }

  const [reportFiles, setReportFiles] = useState([]);
  const getReportList = () => {
    postTransactionReportRequestList({
      reportType: 1, // 1 for Payment and Transaction Report
    })
      .then((data) => {
        setReportFiles(data.data.result);
        setIsReportListActive(true);
      })
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    mobilePos: false,
    pos: false,
    vpos: false,
    cepPos: false,
    merchantStatus: false
  });

  const { data: rawCityList, isLoading: isCityListLoading } = useGetCityList({});
  const cityOptions = useMemo(() => {
    return rawCityList?.data?.map(
      (city: { name: string; cityCode: string }) => ({
        label: `${city.name} (${city.cityCode})`,
        value: Number(city.cityCode),
      })
    ) || [];
  }, [rawCityList?.data]);

  const hasLoading =
    isGetPaymentAndTransactionLoading ||
    isCancelPaymentAndTransactionLoading ||
    isCityListLoading ||
    isRefundPaymentAndTransactionLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <BaseFilterTableWithAccordion summary="Ödeme ve İşlem Raporları" isExpanded={isFilterAccordionExpanded} setExpanded={setFilterAccordionExpand} setTableVisibility={setShowTable}
            actions={
              <Stack direction="row">
                <MaterialButton sx={{ mr: 2 }} onClick={() => onSave()}>
                  <AddchartIcon color="primary" />
                  RAPOR OLUŞTUR
                </MaterialButton>
                <MaterialButton onClick={() => { getReportList(); }}>
                  <BarChartIcon color="primary" />
                  RAPORLAR
                </MaterialButton>
              </Stack>
            }
            child={<Stack spacing={4}>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
              >
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="startDate"
                    control={control}
                    label="Başlangıç Tarihi"
                    defaultValue={dayjs().add(-1, "day")}
                  />
                </FormControl>
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <DatePickerControl
                    sx={{ flex: 1 }}
                    id="endDate"
                    control={control}
                    label="Bitiş Tarihi"
                    defaultValue={dayjs()}
                  />
                </FormControl>
                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  {transactionStatusList && (
                    <Controller
                      name="status"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedStatus = transactionStatusList.find(
                          (option) => option.value === value
                        );

                        return (
                          <Autocomplete
                            id="status"
                            options={transactionStatusList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedStatus || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="İşlem Durumu" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>

                <FormControl sx={{ flex: isDesktop ? 1 : "auto" }}>
                  <InputControl
                    label="Sipariş Numarası"
                    control={control}
                    id="orderId"
                  />
                </FormControl>
              </Stack>
              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
              >
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    label="Kart Numarası"
                    control={control}
                    id="cardNumber"
                  />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <InputControl
                    label="Otorizasyon Kodu"
                    control={control}
                    id="authCode"
                  />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  {payment3DTrxSettingsList && (
                    <Controller
                      name="transactionType"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedTransactionType =
                          payment3DTrxSettingsList.find(
                            (option) => option.value === value
                          );

                        return (
                          <Autocomplete
                            id="transactionType"
                            options={payment3DTrxSettingsList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedTransactionType || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="İşlem Tipi" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>

                <FormControl sx={{ flex: 1 }}>
                  {bankList && (
                    <Controller
                      name="bankCode"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedBank = bankList.find(
                          (option) => option.value === value
                        );

                        return (
                          <Autocomplete
                            id="bankCode"
                            options={bankList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedBank || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="POS Bankası" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>
              </Stack>

              <Stack
                spacing={3}
                direction={isDesktop ? "row" : "column"}
                width={isDesktop ? "100%" : "auto"}
              >
                <FormControl fullWidth sx={{ flex: 2.1 }}>
                  {merchantList && (
                    <Controller
                      control={control}
                      name="filterMerchantId"
                      render={({ field }) => {
                        return (
                          <MerchantSelector
                            field={field}
                            merchantList={merchantList}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  {transactionPaymentModelList && (
                    <Controller
                      name="originalPaymentModel"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value } }) => {
                        const selectedTransactionType =
                          transactionPaymentModelList.find(
                            (option) => option.value === value
                          );

                        return (
                          <Autocomplete
                            id="originalPaymentModel"
                            options={transactionPaymentModelList}
                            getOptionSelected={(option, value) =>
                              option.value === value
                            }
                            getOptionLabel={(option) => option.label}
                            value={selectedTransactionType || null}
                            onChange={(_, newValue) => {
                              onChange(newValue ? newValue.value : "");
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Ödeme Tipi" />
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <Autocomplete
                    id="cityCode"
                    options={cityOptions}
                    value={selectedCity}
                    onChange={(_, value) => setSelectedCity(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Şehir Seçiniz" placeholder="Şehir seçiniz" />
                    )}
                  />
                </FormControl>
              </Stack>

              <Stack
                direction="row"
                justifyContent="flex-end"
                width={isDesktop ? "100%" : "auto"}
                maxWidth={1308}
              >
                <Button
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"ARA"}
                />
              </Stack>
            </Stack>} />
          <Stack flex={1} >
            {showTable && (
              <>
                <Table
                  // className="myTable"
                  isMasterDetailActive={true}
                  isRowExpandable={false}
                  masterDetailContent={PaymentAndTransactionMaster}
                  columnVisibilityConfigKey="paymentAndTranactionFilterColumnVisibilityKey"
                  filterKey="paymentAndTranactionFilter"
                  hasActiveFilters={hasActiveFilters}
                  handleFilterChange={handleFilterChange}
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData?.totalItems || 0}
                  // sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 , height: "100%"}
                  isRowSelectable={() => false}
                  // disableColumnMenu
                  rows={tableData?.result || []}
                  customLabelDisplayedRows={true}
                  autoHeight={false}
                  columns={columns}
                  initialColumnVisibilityModel={columnVisibilityModel}
                  exportFileName="Ödeme ve İslem Raporu"
                  onSave={null}
                  getRowClassName={(params) => {
                    if ((params.row.status.toUpperCase() === 'VOID' && params.row.txnType.toUpperCase() === 'AUTH') ||
                      (params.row.status.toUpperCase() === 'VOID' && params.row.txnType.toUpperCase() === 'PREAUTH') ||
                      (params.row.status.toUpperCase() === 'VOID' && params.row.txnType.toUpperCase() === 'POSTAUTH')) {
                      return 'blocked-row';
                    } else if ((params.row.status === 'SUCCESS' && params.row.updatedStatus.toUpperCase() === 'REFUND')) {
                      return 'pasive-row';
                    } else if ((params.row.status === 'SUCCESS' && params.row.updatedStatus.toUpperCase() === 'PARTIALLY_REFUND')) {
                      return 'merchant-passive-row';
                    } else if (params.row.status === 'Unmatched') {
                      return 'unmatched-row';
                    } else {
                      // if (params.row.merchantStatus === "PASSIVE" || params.row.merchantStatus === "BLOCKED") {
                      if (false) {
                        return "merchant-passive-row";
                      } else {
                        return '';
                      }
                    }
                  }}
                />
              </>
            )}
          </Stack>
        </Stack>
        <ReportRequestListModal
          isOpen={isReportListActive}
          onClose={() => { setIsReportListActive(false); }}
          title="Raporlar"
          reportFiles={reportFiles}
          closeButtonText="Kapat"
          reportType={1}
        ></ReportRequestListModal>
        <DeleteConfirmModal
          isOpen={isCancelModalOpen}
          onClose={handleCloseCancelModal}
          title="İptal Onayı"
          content="Seçili kaydı iptal etmek istiyor musunuz?"
          confirmButtonText="Evet"
          closeButtonText="Hayır"
          onConfirm={() => handleCancelConfirm()}
        ></DeleteConfirmModal>

        <DeleteConfirmModal
          isOpen={isRefundModalOpen}
          onClose={handleCloseRefundModal}
          title="İade Onayı"
          content="Seçili kaydı iade etmek istiyor musunuz?"
          confirmButtonText="Evet"
          closeButtonText="Hayır"
          onConfirm={() => handleRefundConfirm()}
        >
          <FormControl sx={{ width: 290, mt: 3 }}>
            <NumericFormatInputControl
              sx={{ flex: 1 }}
              label="İade Tutarı"
              control={control}
              id="refundAmount"
              adornmentText="TL"
              thousandSeparator=","
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
            />
          </FormControl>
        </DeleteConfirmModal>
      </Stack>
    </>
  );
};